
/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'cross': {
    width: 20,
    height: 20,
    viewBox: '0 0 12 12',
    data: '<path d="M1.126 10.935l9.796-9.796M10.922 10.935L1.126 1.139" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
